import styled, { css } from "styled-components";

export const SpotlightsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  @media (min-width: 990px) {
    margin-top: 4rem;
  }

  .ant-spin {
    position: absolute;
    top: 50vh;
    right: 47vw;
  }

  .main-container-max-width-definer {
    width: 100%;
    overflow: hidden;
    min-height: 400px;
    max-width: 1710px;
    padding-top: 45px;
  }

  .provisional-container-max-width-definer {
    width: 100%;
    overflow: hidden;
    max-width: 1800px;
  }

  .loader-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 70px);
  }

  .loading-point {
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader {
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-spotlight {
    width: 100%;
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1 {
    margin-left: 45px;
  }

  @media screen and (max-width: 1080px) {
    .main-container-max-width-definer,
    .provisional-container-max-width-definer {
      width: calc(100% - 50px);
    }

    h1 {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 450px) {
    .main-container-max-width-definer {
      width: calc(100% - 10px) !important;
    }
  }
`;

interface ICardsContainerProps {
  titleWithNumbers?: boolean;
  showButton?: boolean;
}

export const CardContainer = styled.div<ICardsContainerProps>`
  position: relative;

  .slick-list > div {
    margin-left: 0px;
  }

  .col {
    padding: 0 5px;
  }

  h1 {
    color: ${({ theme }) => theme.mode === "dark" && "#FFFFFF"};
  }

  .title-container {
    display: flex;

    h3 {
      margin-left: 5px;
      color: ${({ theme, titleWithNumbers }) =>
        theme.mode === "dark"
          ? "#FCFCFC !important"
          : titleWithNumbers
          ? "#1890FF"
          : "black"};
      font-size: ${({ titleWithNumbers }) =>
        titleWithNumbers ? "1em" : "1.2em"};
      margin-bottom: ${({ titleWithNumbers }) =>
        titleWithNumbers ? "7px" : null};
    }

    .icon {
      font-size: 1.3em;
      margin: -2px 0 0 8px;
      color: #1890ff;
    }
  }

  .gx-card {
    ${({ theme }) =>
      theme.mode === "dark" &&
      css`
        backdrop-filter: blur(5px) !important;
        background-color: #ffffff1c !important;

        h1,
        h2,
        h3,
        svg {
          color: #ffffff;
        }

        p {
          color: #f7f7f7;
        }
      `}
  }

  .prev-container,
  .next-container {
    width: 100%;
    top: 35%;
    display: ${({ showButton }) => (showButton ? "block" : "none")};
    position: absolute;

    .next-btn,
    .prev-btn {
      z-index: 9999;
      position: absolute;
      font-size: 1.2em;
      padding: 7px;
      box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
      border-radius: 25px;
      color: gray;
      background: white;
    }

    .prev-btn {
      left: 2px;
    }

    .next-btn {
      right: 0;
    }
  }

  .slick-dots {
    margin-top: 25px;
    li {
      background: #c4c4c4;
      height: 5px;
      width: 5px;
      border-radius: 5px;
    }

    .slick-active {
      background: #7f7f7f;
    }
  }
`;
